import { Command } from 'commands/Commands';

export class ChangeBio extends Command {
  type: string = 'Member.ChangeBio';
  priority = 100;
}
